import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { taskTemplateSchemaObject } from "../../Data";
import { validateProperty, validate, Card } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import Joi from "@hapi/joi";
import { PageHeader } from "../../../Common";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../Common/services";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import tokenService from '../../../Common/tokenDecoder';
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const screenCode = "TASKTEMPLATE";

export function TaskTemplateAddEdit(props) {
  const { data, edit } = props.location;
  const [title, setTitle] = useState("Add Task Template");
  const [groups, setGroups] = useState();
  const [estates, setEstates] = useState();
  const [labourTask, setLabourTask] = useState()
  const [devisions, setDevisions] = useState();
  const [alldeductionType, setAllDeductionType] = useState([]);
  const [fields, setFeilds] = useState([]);
  const [taskCategory, setTaskCategory] = useState();
  const [tasktemplate, setTaskTemplate] = useState({
    employeeTaskTemplateID: "0",
    groupID: "0",
    operationEntityID: "0",
    estateTaskID: "0",
    fieldID: "0",
    taskExpiration: "",
    numberOfWorkers: "",
    collectionPointID: "0",
    sundryTask: "0",
    collectionPointName: "",
    isCirculation: false,
    isActive: true,
  });
  const [buttonName, setButtonName] = useState("Save");
  const [errors, setErrors] = useState({});
  const [editScreenFields, setEditScreenFields] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false
  });

  const [pageProperties, setPageProperties] = useState({
    title: "Add User",
    submitButtonName: "Save",
    passwordFieldDisabled: false,
  });

  const schema = Joi.object(taskTemplateSchemaObject).options({
    allowUnknown: true,
  });
  const [stateData, setStateData] = useState(0);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(getEstates());
  }, [tasktemplate.groupID]);

  useEffect(() => {
    trackPromise(getDevisions(), getTaskNames());
  }, [tasktemplate.operationEntityID]);

  useEffect(() => {
    trackPromise(getFeilds());
  }, [tasktemplate.collectionPointID]);

  useEffect(() => {
    trackPromise(getLabourTask());

  }, [tasktemplate.estateTaskID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());

  }, [tasktemplate.sundryTask]);

  function handleIncrement() {
    let stat = stateData;
    stat++;
    setStateData(stat);
  };

  function handleDecrement() {
    let stat = stateData;
    stat--;
    stat >= 0 ?
      setStateData(stat) : setStateData(0)
  };

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "ADDEDITTASKTEMPLATE"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
    });

    if (data && edit) {
      setTitle("Edit Task Template");
      if (data.circulationMonths > 0) {
        setStateData(data.circulationMonths)
        setTaskTemplate({
          ...tasktemplate,
          employeeTaskTemplateID: parseInt(data.employeeTaskTemplateID),
          groupID: parseInt(data.groupID),
          operationEntityID: parseInt(data.operationEntityID),
          estateTaskID: parseInt(data.estateTaskID),
          numberOfWorkers: parseInt(data.numberOfWorkers),
          measurementUnit: data.measurementUnit,
          collectionPointID: parseInt(data.collectionPointID),
          isActive: data.isActive,
          taskExpiration: data.taskExpiration.split('T')[0],
          taskName: data.taskName,
          taskDescription: data.taskDescription,
          taskTemplateCode: data.taskTemplateCode,
          collectionPointName: data.collectionPointName,
          sundryTask: data.labourTaskID,
          isCirculation: true
        });
      }
      else {
        setStateData(0);
        setTaskTemplate({
          ...tasktemplate,
          employeeTaskTemplateID: parseInt(data.employeeTaskTemplateID),
          groupID: parseInt(data.groupID),
          operationEntityID: parseInt(data.operationEntityID),
          estateTaskID: parseInt(data.estateTaskID),
          numberOfWorkers: parseInt(data.numberOfWorkers),
          measurementUnit: data.measurementUnit,
          collectionPointID: parseInt(data.collectionPointID),
          isActive: data.isActive,
          taskExpiration: data.taskExpiration.split('T')[0],
          taskName: data.taskName,
          taskDescription: data.taskDescription,
          taskTemplateCode: data.taskTemplateCode,
          collectionPointName: data.collectionPointName,
          sundryTask: data.labourTaskID,
          isCirculation: false
        });
      }
      setDevisionForEdit();
      setButtonName("Update");
    } else {
      setTitle("Add Task Template");
      var token = tokenService.getUserDetailsFromToken();
      setTaskTemplate({
        ...tasktemplate,
        groupID: token.groupID,
        operationEntityID: token.operationEntityID
      });
    }

    trackPromise(getAllGroups());
  }

  async function setDevisionForEdit() {
    const result = await services.getDivisions(data.operationEntityID);
    setDevisions(result);
  }

  async function getLabourTask() {
    const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(tasktemplate.operationEntityID, tasktemplate.estateTaskID)
    setLabourTask(result)
  }

  async function getDivisionsForDropDown() {
    let data = await services.GetCollectionPointByOperationEntityIDLabourTaskID(tasktemplate.operationEntityID, tasktemplate.sundryTask);
    var options = []
    for (let item of Object.entries(data)) {
      options[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    setAllDeductionType(options);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      groupID: target.value,
      operationEntityID: "0",
      collectionPointID: "0",
      estateTaskID: "0",
      fieldID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      operationEntityID: target.value,
      collectionPointID: "0",
      estateTaskID: "0",
      fieldID: "0",
    });
  }

  function handleCollectionPointChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      collectionPointID: target.value
    });
  }

  function handleTaskCategoryChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      estateTaskID: target.value,
    });
  }

  function handleSundryTaskChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      sundryTask: target.value,
    });
  }

  function SwitchHandleChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value == false) {
      setStateData(0)
    }
    setTaskTemplate({
      ...tasktemplate,
      [e.target.name]: value,
    });
  }

  function handleNoOfWorkersChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      numberOfWorkers: target.value,
    });
  }

  function handleTaskExpirationChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      taskExpiration: target.value,
    });
  }

  function handleActiveChange(target) {
    validateInputs(target);

    setTaskTemplate({
      ...tasktemplate,
      isActive: target.checked,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, taskTemplateSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSave(e) {
    e.preventDefault();

    const errorMessages = validate(schema, tasktemplate);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    saveEdit();
  }

  async function saveEdit() {
    if (!edit) {
      const response = await services.saveTaskTemplate(tasktemplate, fields, stateData);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      afterSuccessfulyChanged(response.statusCode);
    }
    if (edit) {
      const response = await services.editTaskTemplate(tasktemplate, fields, stateData);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      afterSuccessfulyChanged(response.statusCode);
    }
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function afterSuccessfulyChanged(response, factoryItems) {
    if (response === "Success") {
      setTimeout(() => {
        props.history.push({ pathname: "/tasktemplate" });
      }, 1500);
    }
  }

  async function getEstates() {
    const result = await services.GetAllOperationEntityByGroupID(tasktemplate.groupID);
    setEstates(result);
  }

  async function getAllGroups() {
    const result = await services.getGroups();
    setGroups(result);
  }

  async function getDevisions() {
    const result = await services.getDivisions(tasktemplate.operationEntityID);
    setDevisions(result);
  }
  async function getTaskNames() {
    const result = await services.getAllTaskNames(
      tasktemplate.groupID,
      tasktemplate.operationEntityID
    );
    setTaskCategory(result);
  }

  async function getFeilds() {
    const result = await services.getFields(
      tasktemplate.groupID,
      tasktemplate.operationEntityID,
      tasktemplate.collectionPointID
    );

    if (edit && data) {
      var fieldIds = await services.getFeildsByTemplateID(data.taskTemplateID);
      if (fieldIds.length > 0 && result.length > 0) {
        fieldIds.forEach(x => {
          result.forEach(f => {
            if (f.fieldID === x.fieldID && x.isActive === true) {
              f.isChecked = true;
              f.status = 2;
              f.taskTemplateFeildID = x.taskTemplateFeildID
            }
          })
        })
      }
    }

    setFeilds(result);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function clearButton() {
    setTaskTemplate({
      ...tasktemplate,
      tasktemplateId: "",
      groupID: 0,
      operationEntityID: 0,
      fieldID: 0,
      estateTaskID: "",
      taskTemplateCode: "",
      taskName: "",
      taskDescription: "",
      measurementUnit: "",
      taskExpiration: null,
      numberOfWorkers: "",
      collectionPointID: 0,
      isActive: true,
    });
  }

  function getListOfFeilds(key) {
    var nfeilds = [...fields];
    nfeilds.forEach((element) => {
      if (element.fieldID == key) {
        element.isChecked = !element.isChecked;
        if (element.status === 2) {
          element.status = 3;
        } else {
          element.status = 1;
        }
      }
    });
    setFeilds(nfeilds);
  }

  function generateFiledAccordians(data) {
    let items = [];
    if (data != null) {
      data.forEach((element, i) => {
        items.push(
          <Accordion key={i}>
            <AccordionSummary
              aria-label="Expand"
              aria-controls="additional-actions1-content"
              id="additional-actions1-header"
            >
              <FormControlLabel
                aria-label="Acknowledge"
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Checkbox
                    color="primary"
                    checked={element.isChecked}
                    onClick={() => getListOfFeilds(element.fieldID)}
                  />
                }
                id={element.fieldID}
                label={element.fieldName}
              />
            </AccordionSummary>
          </Accordion>
        );
      });
    }
    return items;
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <PageHeader
                  title={title}
                  isButtonEnable={true}
                  buttonText="Back to Listing"
                  path="/tasktemplate"
                />
              </div>
              <hr />

              <form onSubmit={(e) => handleSave(e)}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      disabled={!permissionList.isGroupFilterEnabled || edit}
                      id="groupID"
                      name="groupID"
                      value={tasktemplate.groupID}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["groupID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      disabled={!permissionList.isOperationEntityFilterEnabled || edit}
                      id="operationEntityID"
                      name="operationEntityID"
                      value={tasktemplate.operationEntityID}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(estates)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md">
                    <InputLabel shrink id="estateTaskID">
                      Task Category *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="estateTaskID"
                      name="estateTaskID"
                      value={tasktemplate.estateTaskID}
                      onChange={(e) => handleTaskCategoryChange(e.target)}
                    >
                      <MenuItem value="0">--Select Task Category--</MenuItem>
                      {generateDropDownMenu(taskCategory)}
                    </Select>
                    {errors["taskCategory"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["taskCategory"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="sundryTask">Sundry Task *</InputLabel>
                    <Select
                      fullWidth
                      id="sundryTask"
                      name="sundryTask"
                      value={tasktemplate.sundryTask}
                      onChange={(e) => handleSundryTaskChange(e.target)}>
                      <MenuItem value="0">--Select Sundry Task--</MenuItem>
                      {generateDropDownMenu(labourTask)}
                    </Select>
                    {errors["sundryTask"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["sundryTask"]}</FormHelperText>)}
                  </div>

                </div>
                <div className="form-group row" >
                  <div className="col-md pb-1" hidden={edit}>
                    <InputLabel shrink id="collectionPointID">
                      Collection Point *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="collectionPointID"
                      name="collectionPointID"
                      value={tasktemplate.collectionPointID}
                      onChange={(e) => handleCollectionPointChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(alldeductionType)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md" hidden={!edit}>
                    <InputLabel shrink id="collectionPointName">
                      Collection Point *
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="collectionPointName"
                      disabled={edit}
                      id="collectionPointName"
                      onChange={(e) => handleNoOfWorkersChange(e.target)}
                      value={tasktemplate.collectionPointName}
                    />
                    {errors["numberOfWorkers"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["numberOfWorkers"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="taskExpiration">
                      Task Expiration{" "}
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="taskExpiration"
                      name="taskExpiration"
                      type="date"
                      value={tasktemplate.taskExpiration}
                      onChange={(e) => handleTaskExpirationChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["taskExpiration"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["taskExpiration"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md">
                    <InputLabel shrink id="numberOfWorkers">
                      Number Of Workers *
                    </InputLabel>
                    <TextField
                      fullWidth
                      type="number"
                      name="numberOfWorkers"
                      id="numberOfWorkers"
                      onChange={(e) => handleNoOfWorkersChange(e.target)}
                      value={tasktemplate.numberOfWorkers}
                    />
                    {errors["numberOfWorkers"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["numberOfWorkers"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <label htmlFor="switch1">Circulation</label>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <input
                      className="mr-2"
                      id="isCirculation"
                      type="checkbox"
                      switch="none"
                      name="isCirculation"
                      onChange={(e) => SwitchHandleChange(e)}
                      checked={tasktemplate.isCirculation}
                    />
                    <label
                      htmlFor="isCirculation"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                    {tasktemplate.isCirculation ? (
                      <div className="col-md pb-1">
                        <InputLabel shrink id="def">Months</InputLabel>
                        <ButtonGroup size="small" aria-label="small outlined button group">
                          <Button onClick={handleDecrement}>-</Button>
                          {stateData >= 0 && <Button>{stateData}</Button>}
                          {stateData >= 0 && <Button onClick={handleIncrement}>+</Button>}
                        </ButtonGroup>
                      </div>
                    ) : null}
                  </div>
                </div>
                <label htmlFor="switch1">Active</label>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <input
                      className="mr-2"
                      id="isActive"
                      switch="none"
                      type="checkbox"
                      name="isActive"
                      onChange={(e) => handleActiveChange(e.target)}
                      checked={tasktemplate.isActive}
                    />
                    <label
                      htmlFor="isActive"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>

                <label htmlFor="switch1">Select Fields</label>
                <div className="col-md-6">
                  {generateFiledAccordians(fields)}
                </div>

                <MessageModal
                  hidden={messageModel.hidden}
                  messageType={messageModel.type}
                  messageDescription={messageModel.disciption}
                  clicked={modalDismissHandler}
                />

                <div className="card-footer">
                  <input
                    disabled={validate(schema, tasktemplate)}
                    type="button"
                    className="btn btn-primary"
                    value={buttonName}
                    onClick={handleSave}
                  />
                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={clearButton}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
